import { Box, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { InfoOutlined } from '@material-ui/icons';
import { Layout } from '@roc/client-portal-shared/components';
import { Paper } from '@roc/ui';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(6, 4),
      borderRadius: theme.spacing(2),
      boxShadow:
        'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
    },
    icon: {
      fontSize: 72,
      color: theme.palette.info.main,
      marginBottom: theme.spacing(2),
    },
  })
);

const PaymentNotAvailable = () => {
  const classes = useStyles();

  return (
    <Layout>
      <Box my={3}>
        <Typography variant="h3" gutterBottom>
          Valuation Payment
        </Typography>
      </Box>
      <Paper className={classes.paper}>
        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid item>
            <InfoOutlined className={classes.icon} />
          </Grid>
          <Grid item>
            <Typography variant="h4" align="center">
              Pricing Not Available
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1" align="center" color="textSecondary">
              We are currently working with the AMC to obtain accurate appraisal pricing. We will keep you informed as soon as we receive an update.
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Layout>
  );
};

export default PaymentNotAvailable;
